/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TasksV2SubTypesEnum } from './tasksV2SubTypesEnum';
import { BackupOperationEnum } from './backupOperationEnum';
import { ServiceTypeEnum } from './serviceTypeEnum';
import { TaskResourceType } from './taskResourceType';
import { TasksV2TypesEnum } from './tasksV2TypesEnum';
import { VcdsServiceTypeEnum } from './vcdsServiceTypeEnum';


export interface TaskBackupSpec { 
    /**
     * The end period of the retention/ purge
     */
    end_date?: string;
    operation: BackupOperationEnum;
    resource_type?: TaskResourceType;
    /**
     * To retain the records in the task table (Applicable only for PURGE operation)
     */
    retain?: boolean;
    service_type?: ServiceTypeEnum;
    /**
     * The start period of the retention/ purge
     */
    start_date?: string;
    task_id?: string;
    task_sub_type?: TasksV2SubTypesEnum;
    task_type?: TasksV2TypesEnum;
    vcds_service_type?: VcdsServiceTypeEnum;
}
export namespace TaskBackupSpec {
}


